export default __webpack_public_path__ + "static/media/Girdle of the Triumphant.1232f9cc.jpg";